import DOMPurify from 'dompurify';
import Vue from 'vue';

function sanitizeHtml(html, modifiers = {}) {
  const config = {};

  if (modifiers.tasks) {
    // Add 'target' to allowed attributes for notes, keeping other default safe attributes
    config.ADD_ATTR = ['target', 'rel'];
  }

  let sanitized = DOMPurify.sanitize(html, config);

  // Automatically add rel="noopener noreferrer" to links with target="_blank"
  const temp = document.createElement('div');
  temp.innerHTML = sanitized;
  temp.querySelectorAll('a[target="_blank"]').forEach((a) => {
    if (!a.getAttribute('rel')) a.setAttribute('rel', 'noopener noreferrer');
  });

  return temp.innerHTML;
}

function handleHtml(el, binding) {
  if (binding?.value) {
    el.innerHTML = sanitizeHtml(binding.value, binding.modifiers);
  } else {
    el.innerHTML = '';
  }
}

Vue.directive('sanitize-html', {
  bind(el, binding) {
    handleHtml(el, binding);
  },
  update(el, binding) {
    handleHtml(el, binding);
  },
});
